import React from 'react';
/**
 * Registers a given panel component. Also runs a `useEffect` that will
 * automatically de-register then panel on unmount.
 * @param registerComponent
 * @param ComponentType
 * @param hydrate
 * @param dehydrate
 */
export default function usePanelRegistration(registerComponent, ComponentType, hydrate, dehydrate) {
  var _ComponentType$COMPON;
  var name = (_ComponentType$COMPON = ComponentType.COMPONENT) !== null && _ComponentType$COMPON !== void 0 ? _ComponentType$COMPON : ComponentType.displayName;
  if (name == null) {
    throw new Error('ComponentType must have a `COMPONENT` or `displayName` attribute.');
  }
  React.useEffect(() => {
    var deregister = registerComponent(name, ComponentType, hydrate, dehydrate);
    return () => {
      deregister();
    };
  }, [ComponentType, dehydrate, hydrate, name, registerComponent]);
}
//# sourceMappingURL=usePanelRegistration.js.map